import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, PageHeader, EmptyState } from '@/components/ui'
import { Truck } from 'lucide-react'

export const Route = createFileRoute('/store/$id/shipping')({
  component: StoreShippingPage,
})

function StoreShippingPage() {
  return (
    <>
      <PageHeader title="Envíos" description="Zonas y tarifas de envío" />
      <div className="p-8">
        <Card>
          <CardContent className="p-0">
            <EmptyState
              title="Sin zonas de envío configuradas"
              description="Schema shipping_zones + shipping_rates listo. Falta CRUD + integración con plugins de envío (Servientrega, Coordinadora, Interrapidísimo, etc.)."
            />
            <div className="border-t border-neutral-800 p-4 text-xs text-neutral-500 flex items-center gap-2">
              <Truck className="size-4" />
              <span>Endpoint pendiente: <code className="text-neutral-300">GET /api/v1/shipping/zones</code></span>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
